const typographyModalCloneCheckSite = {
  text: 'Clone Service Types'
};

export default typographyModalCloneCheckSite;
